export const GET_DDA_POLICY = "GET_DDA_POLICY";
export const GET_DDA_POLICY_SUCCESS = "GET_DDA_POLICY_SUCCESS";
export const GET_DDA_POLICY_FAILURE = "GET_DDA_POLICY_FAILURE";

export const CREATE_EDDA = "CREATE_EDDA";
export const CREATE_EDDA_SUCCESS = "CREATE_EDDA_SUCCESS";
export const CREATE_EDDA_FAILURE = "CREATE_EDDA_FAILURE";

export const GET_GIRO_BANK_LIST = "GET_GIRO_BANK_LIST";
export const GET_GIRO_BANK_LIST_SUCCESS = "GET_GIRO_BANK_LIST_SUCCESS";
export const GET_GIRO_BANK_LIST_FAILURE = "GET_GIRO_BANK_LIST_FAILURE";

export const GET_GIRO_CALL_BACK_DATA = "GET_GIRO_CALL_BACK_DATA";
export const GET_GIRO_CALL_BACK_DATA_SUCCESS =
  "GET_GIRO_CALL_BACK_DATA_SUCCESS";
export const GET_GIRO_CALL_BACK_DATA_FAILURE =
  "GET_GIRO_CALL_BACK_DATA_FAILURE";

export const SUBMIT_GIRO_DATA = "SUBMIT_GIRO_DATA";
export const SUBMIT_GIRO_SUCCESS = "SUBMIT_GIRO_SUCCESS";
export const SUBMIT_GIRO_FAILURE = "SUBMIT_GIRO_FAILURE";

export const GET_GIRO_CALL_BACK_EXIST = "GET_GIRO_CALL_BACK_EXIST";
export const GET_GIRO_CALL_BACK_EXIST_SUCCESS =
  "GET_GIRO_CALL_BACK_EXIST_SUCCESS";
export const GET_GIRO_CALL_BACK_EXIST_FAILURE =
  "GET_GIRO_CALL_BACK_EXIST_FAILURE";

export const GET_GIRO_SUBMIT_CALL_BACK_EXIST =
  "GET_GIRO_SUBMIT_CALL_BACK_EXIST";
export const GET_GIRO_SUBMIT_CALL_BACK_EXIST_SUCCESS =
  "GET_GIRO_SUBMIT_CALL_BACK_EXIST_SUCCESS";
export const GET_GIRO_SUBMIT_CALL_BACK_EXIST_FAILURE =
  "GET_GIRO_SUBMIT_CALL_BACK_EXIST_FAILURE";

export const ENROL_EGIRO = "ENROL_EGIRO";
export const ENROL_EGIRO_SUCCESS = "ENROL_EGIRO_SUCCESS";
export const ENROL_EGIRO_FAILURE = "ENROL_EGIRO_FAILURE";

export const CONFIRM_PAY_EDDA_GI_RENEWAL = "CONFIRM_PAY_EDDA_GI_RENEWAL";
export const CONFIRM_PAY_EDDA_GI_RENEWAL_SUCCESS = "CONFIRM_PAY_EDDA_GI_RENEWAL_SUCCESS";
export const CONFIRM_PAY_EDDA_GI_RENEWAL_FAILURE = "CONFIRM_PAY_EDDA_GI_RENEWAL_FAILURE";

//Get DDA Policy
export const getDDAPolicy = (policyNumber,GiroReference) => ({
  type: "GET_DDA_POLICY",
  policyNumber,
  GiroReference
});

export const getDDAPolicySuccess = (data) => ({
  type: "GET_DDA_POLICY_SUCCESS",
  data,
});

export const getDDAPolicyFailure = (message) => ({
  type: "GET_DDA_POLICY_FAILURE",
  message,
});

//create EDDA
export const createEDDA = (policyNumber, policyName, premium, bankID,transactionType, orderNumber,
  ewalletAmount,
  isRecurring) => ({
  type: "CREATE_EDDA",
  policyNumber,
  policyName,
  premium,
  bankID,
  transactionType,orderNumber,
  ewalletAmount,
  isRecurring
});

export const createEDDASuccess = (data) => ({
  type: "CREATE_EDDA_SUCCESS",
  data,
});

export const createEDDAFailure = (message) => ({
  type: "CREATE_EDDA_FAILURE",
  message,
});

//Get GIRO Bank List
export const getGIROBankList = (transactionType) => ({
  type: "GET_GIRO_BANK_LIST",transactionType
});

export const getGIROBankListSuccess = (data) => ({
  type: "GET_GIRO_BANK_LIST_SUCCESS",
  data,
});

export const getGIROBankListFailure = (message) => ({
  type: "GET_GIRO_BANK_LIST_FAILURE",
  message,
});

//Get GIRO CALL BACK DATA
export const getGiroCallBackData = (id) => ({
  type: "GET_GIRO_CALL_BACK_DATA",
  id,
});

export const getGiroCallBackDataSuccess = (data) => ({
  type: "GET_GIRO_CALL_BACK_DATA_SUCCESS",
  data,
});

export const getGiroCallBackDataFailure = (message) => ({
  type: "GET_GIRO_CALL_BACK_DATA_FAILURE",
  message,
});

//Giro Call Back Exist
export const getGiroCallBackExistData = (ddaRefNo, bankTransId) => ({
  type: "GET_GIRO_CALL_BACK_EXIST",
  ddaRefNo,
  bankTransId,
});

export const getGiroCallBackExistSuccess = (data) => ({
  type: "GET_GIRO_CALL_BACK_EXIST_SUCCESS",
  data,
});

export const getGiroCallBackExistFailure = (message) => ({
  type: "GET_GIRO_CALL_BACK_EXIST_FAILURE",
  message,
});

//submit Giro
export const submitGiroData = (
  ddaRefNo,
  bankTransId,
  payorName,
  payorNric,
  payorRelationship,
  attachedFile,
  isThirdParty,
  isMatch
) => ({
  type: "SUBMIT_GIRO_DATA",
  ddaRefNo,
  bankTransId,
  payorName,
  payorNric,
  payorRelationship,
  attachedFile,
  isThirdParty,
  isMatch,
});

export const submitGiroSuccess = (data) => ({
  type: "SUBMIT_GIRO_SUCCESS",
  data,
});

export const submitGiroFailure = (message) => ({
  type: "SUBMIT_GIRO_FAILURE",
  message,
});

//Giro Submit Call Back Exist
export const getGiroSubmitCallBackExistData = (ddaRefNo, bankTransId) => ({
  type: "GET_GIRO_SUBMIT_CALL_BACK_EXIST",
  ddaRefNo,
  bankTransId,
});

export const getGiroSubmitCallBackExistSuccess = (data) => ({
  type: "GET_GIRO_SUBMIT_CALL_BACK_EXIST_SUCCESS",
  data,
});

export const getGiroSubmitCallBackExistFailure = (message) => ({
  type: "GET_GIRO_SUBMIT_CALL_BACK_EXIST_FAILURE",
  message,
});

//Enrol E Giro
export const enroleGiro = (ddaRefNo, transactionRefNo) => ({
  type: "ENROL_EGIRO",
  ddaRefNo, transactionRefNo
});

export const enroleGiroSuccess = (data) => ({
  type: "ENROL_EGIRO_SUCCESS",
  data,
});

export const enroleGiroFailure = (message) => ({
  type: "ENROL_EGIRO_FAILURE",
  message,
});

//confirmPayEddaGiRenewal
export const confirmPayEddaGiRenewal = (orderNumber) => ({
  type: "CONFIRM_PAY_EDDA_GI_RENEWAL",
  orderNumber
});

export const confirmPayEddaGiRenewalSuccess = (data) => ({
  type: "CONFIRM_PAY_EDDA_GI_RENEWAL_SUCCESS",
  data,
});

export const confirmPayEddaGiRenewalFailure = (message) => ({
  type: "CONFIRM_PAY_EDDA_GI_RENEWAL_FAILURE",
  message,
});


